import { Button, Stack, Typography, ValidationErrors, newToast } from "@compass/core";
import { SubmitButton } from "components";
import { Export, Survey, SurveyReportRequest, SurveyReportResponse } from "generated/openApi";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const SurveyReportReportHeader = (props: {
  handle: string;
  _export: Export | undefined;
  // selectedSurveyReport: Survey | undefined;
  surveyReportRequest: SurveyReportRequest | undefined;
  setSurveyReportData: React.Dispatch<React.SetStateAction<SurveyReportResponse | undefined>>;
  screen: "config" | "grid";
  setScreen: React.Dispatch<React.SetStateAction<"config" | "grid">>;
  setValidationErrors: (errors: ValidationErrors) => void;
}) => {
  const dispatch = useDispatch();

  const generateGridData = (_export: Export | undefined) => {
    props.setValidationErrors({});

    // const surveyRequest: SurveyReportRequest = { surveyReportId: props.selectedSurveyReport!.id };

    ApiService.surveyReports
      .generateSurveyReport(props.surveyReportRequest!)
      .then((response) => {
        props.setSurveyReportData(response);
        props.setScreen("grid");
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.data);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {props.screen === "config" && (
          <SubmitButton label="Generate" disabled={!props.surveyReportRequest?.surveyReportId} onClick={() => generateGridData(props._export)} />
        )}
        {props.screen === "grid" && (
          <>
            <Button onClick={() => props.setScreen("config")} variant="outlined">
              Back
            </Button>
            <SubmitButton label="Apply Filters" disabled={!props.surveyReportRequest?.surveyReportId} onClick={() => generateGridData(props._export)} />
          </>
        )}
      </Stack>
    </Stack>
  );
};
